import { BaseAdReporter } from '../AdPlayer/BaseAdReporter';
import { AD_MEDIUM_TYPES, AD_SLOTS } from '../AdPlayer/constants';
import { api } from '../singletons';
const OUTSTREAM_MAX_ROLLS = 1;
export class OutstreamVideoAdReporter extends BaseAdReporter {
    #didReportAdBreakInterrupted = false;
    #sessionMetadata;
    get errorLogPrefix() {
        return 'Outstream ad';
    }
    get adRequestUrl() {
        return this.#sessionMetadata?.adRequestUrl;
    }
    get sessionAdRequestId() {
        return this.#sessionMetadata?.adRequestId;
    }
    get biddingNetworks() {
        return this.#sessionMetadata?.biddingNetworks || [];
    }
    getAdErrorPrefix() {
        return 'Outstream Video Ad';
    }
    set sessionMetadata(sessionMetadata) {
        this.#sessionMetadata = sessionMetadata;
        this.#didReportAdBreakInterrupted = false;
        this.resetReportingState();
    }
    getAdsBiddingAdSlot() {
        return AD_SLOTS.NOWPLAYING_MREC_VIDEO;
    }
    getAdParameters(adEvent) {
        const sourceAdEvent = this.getReportingAdEvent(adEvent);
        const { requestId, bitrate, totalAds, creativeId, adPosition = 1, destinationUrl, } = sourceAdEvent || {};
        const { adUnitId, adNetworkName, adRequestId } = this.#sessionMetadata || {};
        const playedAdsCount = this.getPlayedTrackedAdEventsCount();
        return {
            adUnitId: adUnitId || '',
            adNetworkName: adNetworkName || '',
            adRequestId: requestId || adRequestId || 'none',
            adSlot: AD_SLOTS.NOWPLAYING_MREC_VIDEO,
            adType: AD_MEDIUM_TYPES.VIDEO,
            adRequestDefaultTimer: true,
            midrollTimerInSeconds: 0,
            bitrate: bitrate || 0,
            maxRolls: OUTSTREAM_MAX_ROLLS,
            maxTotalRolls: OUTSTREAM_MAX_ROLLS,
            noOfVideoaudiorollRequested: OUTSTREAM_MAX_ROLLS,
            noOfVideoaudiorollsPlayed: playedAdsCount,
            noOfVideoaudiorollsReceived: totalAds || OUTSTREAM_MAX_ROLLS,
            adCreativeId: creativeId || '',
            currentVideoaudiorollIdx: Math.max(adPosition - 1, 0),
            wasAdCancelled: this.wasAdCancelled,
            wasAdSkipped: this.wasAdSkipped,
            isStreamPrebuffered: false,
            prebufferTimeMs: 0,
            props: {},
            destinationUrl: destinationUrl || '',
        };
    }
    reportAdBreakInterrupted() {
        if (this.#didReportAdBreakInterrupted) {
            return;
        }
        this.#didReportAdBreakInterrupted = true;
        this.finalizePendingLoadedAdFailure('Outstream ad break ended before all received ads were attempted', 'Outstream Video Ad, Ad Break Interrupted Before Completion');
    }
    reportEligibility({ isEligible, isPlatformEligible }) {
        api.telemetry.reportAdsVideoAudioRollEligibilityDecided({
            adSlot: AD_SLOTS.NOWPLAYING_MREC_VIDEO,
            adType: AD_MEDIUM_TYPES.VIDEO,
            isPlatformEligible,
            isEligible,
            maxRolls: OUTSTREAM_MAX_ROLLS,
            maxTotalRolls: OUTSTREAM_MAX_ROLLS,
        });
    }
}
